import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Code = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Code' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M9,22 L15,2 M17,17 L22,12 L17,7 M7,17 L2,12 L7,7' />
  </StyledIcon>
);
